import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import secureLocalStorage from "react-secure-storage";
import CompanyService from "../../../Services/CompanyService";
import DataParser from "../../../utlits/Dataparser";
import { Helmet } from "react-helmet";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import SocketService from "../../../Services/SocketService";
import TableSkeleton from "../../Reuseable/TableSkeleton";

message.config({ zIndex: 1000000001 });

const Roles = () => {
  const [rolesList, setRoleList] = useState([]);
  const [userPermissions, setuserPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [deleteModal, setDeleteModal] = useState({ visible: false, roleId: null });
  const navigate = useNavigate();
  const companyId = DataParser.CompanyId();

  useEffect(() => {
    if (pageSize > 15) {
      setCurrentPage(1);
    }
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const getData = () => {
    setIsLoading(true);
    CompanyService.getCompanyRoles(companyId)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        setRoleList(res.data.roles || []);
      })
      .catch((err) => {
        console.error("Error fetching roles:", err);
        message.error("Failed to load roles. Please try again!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  useEffect(() => {
    SocketService.connect();

    const handleRoleUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        getData();
      }
    };

    SocketService.on("role_update", handleRoleUpdate);
    return () => {
      SocketService.off("role_update", handleRoleUpdate);
    };
  }, [companyId]);

  const handelDeleteItem = (e, id) => {
    e.preventDefault();
    setDeleteModal({ visible: true, roleId: id });
  };

  const confirmDelete = async () => {
    const id = deleteModal.roleId;
    setRoleList((prev) => prev.filter((el) => el.id !== id));
    setDeleteModal({ visible: false, roleId: null });
    try {
      const res = await CompanyService.deleteCompanyRoles(id);
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      } else {
        message.success("Role deleted successfully!");
      }
      getData();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to delete role. Please try again!");
    }
  };

  const handelEditItem = (e, item) => {
    e.preventDefault();
    navigate(`/${DataParser.CompanyIdentifierRole()}/roles/edit`, {
      state: { data: item },
    });
  };

  const PaginatedData = paginate(rolesList, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Roles - Planit</title>
      </Helmet>

      {deleteModal.visible && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }} onClick={() => setDeleteModal({ visible: false, roleId: null })}>
          <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Role</h5>
                <button type="button" className="btn-close" onClick={() => setDeleteModal({ visible: false, roleId: null })} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this role?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button
                  type="button"
                  className="btn btn-danger waves-effect waves-light"
                  style={{ borderRadius: "5px", fontSize: "13px" }}
                  onClick={confirmDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Roles</li>
                    </ol>
                    {userPermissions.indexOf("departments-create") !== -1 ? (
                      <Link to={`/${DataParser.CompanyIdentifierRole()}/roles/create`}>
                        <button type="button" className="btn btn-primary waves-effect waves-light" style={{ borderRadius: "5px" }}>
                          Create Role
                        </button>
                      </Link>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Role
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Role Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={3} rows={6} />
                          ) : (
                            <>
                              {PaginatedData && PaginatedData.length > 0 ? (
                                PaginatedData.map((item, index) => (
                                  <tr key={item.id}>
                                    <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                    <td>{item.name}</td>
                                    <td className="tableset">
                                      {item.name === "Company Admin" ? (
                                        <>
                                          <span className="uil-trash iconscolor" style={{ visibility: "hidden" }} />
                                          &nbsp;
                                          <span className="uil-pen iconscolor" style={{ visibility: "hidden" }} />
                                        </>
                                      ) : (
                                        <>
                                          {userPermissions.indexOf("role-delete") !== -1 ? (
                                            <Link
                                              to="#"
                                              className="cursor-pointer iconscolor"
                                              onClick={(e) => handelDeleteItem(e, item.id)}
                                            >
                                              <Tooltip title="Delete Role">
                                                <i className="uil-trash iconscolor" />
                                              </Tooltip>
                                            </Link>
                                          ) : (
                                            <span
                                              className="uil-trash iconscolor text-muted"
                                              style={{ cursor: "not-allowed", opacity: 0.5 }}
                                              title="You don't have permission to delete"
                                            />
                                          )}
                                          {userPermissions.indexOf("role-edit") !== -1 ? (
                                            <Link
                                              to="#"
                                              className="cursor-pointer iconscolor"
                                              onClick={(e) => handelEditItem(e, item)}
                                            >
                                              <Tooltip title="Edit Role">
                                                <i className="uil-pen iconscolor" />
                                              </Tooltip>
                                            </Link>
                                          ) : (
                                            <span
                                              className="uil-pen iconscolor text-muted"
                                              style={{ cursor: "not-allowed", opacity: 0.5 }}
                                              title="You don't have permission to edit"
                                            />
                                          )}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No roles found. Click 'Create Role' to add one.
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>

                      {rolesList.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={rolesList.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Roles;
